<ng-container *ngIf="structure">

    <div class="row no-gutters mb-3">
        <div class="col-sm-12 manual-automatic-radio-group">
            <label class="mr-2">{{ structure.trans.generation_method | translate }}:</label>
            <mat-radio-group [(ngModel)]="structure.generation_method">
                <mat-radio-button id="{{idPrefix}}input_radio.generation_method.{{GenerationMethods.MANUAL.key}}"
                                  class="ml-2"
                                  value="{{ GenerationMethods.MANUAL.key }}">{{ GenerationMethods.MANUAL.trans | translate }}
                </mat-radio-button>
                <mat-radio-button id="{{idPrefix}}input_radio.generation_method.{{GenerationMethods.AUTOMATIC.key}}"
                                  class="ml-2"
                                  value="{{ GenerationMethods.AUTOMATIC.key }}">
                    {{ GenerationMethods.AUTOMATIC.trans | translate }}
                </mat-radio-button>
            </mat-radio-group>
        </div>
    </div>


    <div class="row no-gutters">
        <div class="col-sm-11">
            <div class="smp-title-thin-border mb-3" [ngClass]="{ 'disabled': !isAutomatic }">{{ 'case_number_management.title.structure' | translate }} </div>
        </div>
    </div>

    <div class="row no-gutters mb-3">
        <div class="col-sm-12" [ngClass]="{ 'text-disabled': !isAutomatic }">
            <strong class="mr-2">{{ 'common.label.example' | translate }}: </strong>
            <ng-container *ngFor="let field of structure.fields">

                <ng-container *ngIf="field.identifier_code === FieldCode.CONSECUTIVE_NUMBER">
                    <span *ngFor="let num of numberAsNumberArray(field.length)">{{ num }}</span>
                </ng-container>

                <ng-container *ngIf="field.identifier_code !== FieldCode.CONSECUTIVE_NUMBER">
                    <span>{{ FieldCodes.getByKey(field.identifier_code).trans2 | translate | uppercase }}</span>
                </ng-container>

                <span>{{ ' ' }}</span>

            </ng-container>
        </div>
    </div>

    <div class="row no-gutters mb-5 ">
        <div class="col-sm-12">
            <drag-n-drop-chips [(bananaBox)]="structure.fields"
                               [selectionList]="filteredAvailableFields"
                               [selectionListLabel]="'case_number_management.label.add_case_number_field' | translate"
                               [idPrefix]="idPrefix"
                               (bananaBoxChange)="filterAvailableFields()"
                               [disabled]="disabled || !isAutomatic">
            </drag-n-drop-chips>
        </div>
    </div>

    <div class="row no-gutters">
        <div class="col-sm-11">
            <div class="smp-title-thin-border mb-4" [ngClass]="{ 'disabled': !isAutomatic }">{{ 'case_number_management.title.consecutive_number_settings' | translate }} </div>
        </div>
    </div>

    <div class="row no-gutters">
        <div class="col-sm-6">
            <div class="row no-gutters">
                <div class="col-sm-10">
                    <div class="row no-gutters">

                        <div class="col-sm-4">
                            <mat-label class="counter-length-label"[ngClass]="{ 'text-disabled': !isAutomatic }">{{ structure.trans.counter_length | translate }}:</mat-label>
                        </div>

                        <div class="col-sm-8">
                            <div class="row no-gutters">
                                <div class="col-sm-12 slider-column-padding">
                                    <div class="full-width slider-column">
                                        <div *ngFor="let step of sliderSteps" class="smp-slider-label slider-label-{{step}}" [ngClass]="{ 'text-disabled': !isAutomatic }">{{ step }}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row no-gutters">
                                <div class="col-sm-12">
                                    <mat-slider class="full-width"
                                                id="{{idPrefix}}input_slider.consecutive_number"
                                                [(ngModel)]="structure.getField(FieldCode.CONSECUTIVE_NUMBER).length"
                                                [disabled]="disabled || !isAutomatic"
                                                [min]="sliderConfig.min"
                                                [max]="sliderConfig.max"
                                                [step]="sliderConfig.step"
                                                [tickInterval]="sliderConfig.tickInterval"
                                                [thumbLabel]="sliderConfig.thumbLabel">
                                    </mat-slider>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row no-gutters">
                        <div class="col-sm-5">
                            <mat-form-field class="full-width">
                                <mat-label>{{ structure.trans.counter_start | translate }}</mat-label>
                                <input id="{{idPrefix}}input_text.counter_start"
                                       type="text" matInput only-digits
                                       [(ngModel)]="structure.counter_start"
                                       [disabled]="disabled || !isAutomatic">
                            </mat-form-field>
                        </div>

                        <div class="col-sm-5 offset-sm-2">
                            <mat-form-field class="full-width">
                                <mat-label>{{ structure.trans.counter_next_value | translate }}</mat-label>
                                <input id="{{idPrefix}}input_text.counter_next_value"
                                       type="text" matInput only-digits
                                       [(ngModel)]="structure.counter_next_value"
                                       [disabled]="disabled || !isAutomatic">
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <div class="col-sm-2">

                </div>

            </div>
        </div>


        <div class="col-sm-6">
            <div class="row no-gutters">
                <div class="col-sm-10">
                    <div class="row no-gutters">

                        <div class="col-sm-6">
                            <mat-label class="counter-length-label" [ngClass]="{ 'text-disabled': !isAutomatic }">{{ structure.trans.counter_reset_method | translate }}:</mat-label>
                        </div>

                        <div class="col-sm-6">
                            <mat-radio-group class="reset-method-radio-group full-width"
                                             [(ngModel)]="structure.counter_reset_method"
                                             [disabled]="disabled || !isAutomatic">
                                <mat-radio-button class="reset-method-radio-button full-width"
                                                  *ngFor="let resetMethod of CounterResetMethods.ALL"
                                                  id="{{idPrefix}}input_radio.counter_reset_method.{{resetMethod.key}}"
                                                  [value]="resetMethod.key">
                                    {{ resetMethod.trans | translate }}
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </div>

                <div class="col-sm-2">

                </div>

            </div>

        </div>
    </div>

    <div class="row mt-5">

        <div class="offset-lg-6 col-xs-12 col-md-6 col-lg-3">
            <a mat-stroked-button
               color="primary"
               class="full-width"
               id="{{idPrefix}}btn.cancel"
               (click)="cancel()">
                {{ 'common.btn.cancel' | translate | uppercase }}
            </a>
        </div>

        <div class="col-xs-12 col-md-6 col-lg-3">
            <button mat-flat-button
                    color="accent"
                    class="full-width"
                    id="{{idPrefix}}btn.save"
                    (click)="save()">
                {{ 'common.btn.save' | translate | uppercase }}
            </button>
        </div>

    </div>

</ng-container>
